import { HIGHLIGHTS } from './highlights';
import { readStringList, addToStringList } from '../product-guides/progress';

export { HIGHLIGHTS } from './highlights';
export { WELCOME_SLIDES } from './welcome';

export const WELCOME_STORAGE_KEY = 'company_welcome_seen';
export const HIGHLIGHTS_STORAGE_KEY = 'company_highlights_seen';
// Avvisa i puntini del menu quando una novità è stata vista, anche da un'altra pagina.
export const HIGHLIGHTS_EVENT = 'heyjob:highlights-seen';

const NEWS_FILTERS = ['all', 'updates', 'guides'];

export function isCompanyUser(user) {
  const groups = user?.groups ?? user?.data?.groups ?? [];
  return groups.includes('Azienda');
}

function isWelcomeSeen() {
  try {
    return localStorage.getItem(WELCOME_STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
}

export function shouldShowWelcome(user, search) {
  return isCompanyUser(user) && !new URLSearchParams(search).has('tour') && !isWelcomeSeen();
}

export function markWelcomeSeen() {
  try {
    localStorage.setItem(WELCOME_STORAGE_KEY, '1');
  } catch (error) {
    // Il browser non permette di salvare: il benvenuto potrà ricomparire al prossimo accesso.
  }
}

export function getHighlight(id) {
  return HIGHLIGHTS.find((highlight) => highlight.id === id) ?? null;
}

export function isHighlightSeen(id) {
  return readStringList(HIGHLIGHTS_STORAGE_KEY).includes(id);
}

export function markHighlightSeen(id) {
  addToStringList(HIGHLIGHTS_STORAGE_KEY, id);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(HIGHLIGHTS_EVENT));
  }
}

export function parseNewsFilter(value) {
  return NEWS_FILTERS.includes(value) ? value : 'all';
}
